import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/orcamentos',
  component: mainComponent,
  title: 'Orçamentos',
  children: [{
      path: '/',
      name: 'quote-list',
      component: () => import('@/views/quote/QuotesList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Comercial' },
          { title: 'Orçamentos', active: true },
        ],
        pageTitle: 'Orçamentos',
        rule: 'editor'
      },
    },
    {
      path: 'novo',
      name: 'quote-new',
      component: () => import('@/views/quote/NewQuote.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Comercial' },
          { title: 'Orçamentos', url: '/orcamentos' },
          { title: 'Novo', active: true },
        ],
        pageTitle: 'Novo Orçamento',
        rule: 'editor'
      },
    },
    {
      path: 'editar/:idQuote',
      name: 'quote-edit',
      component: () => import('@/views/quote/EditQuote.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Comercial' },
          { title: 'Orçamentos', url: '/orcamentos' },
          { title: 'Editar', active: true },
        ],
        pageTitle: 'Editar Orçamento',
        rule: 'editor'
      },
    }
  ],
}, ];